import getDisplayName from 'utils/getDisplayName'

const withPermissions = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      permissions: { allowInvoiceRetailers },
    } = props

    return (
      <WrappedComponent
        canViewPaymentProviders={allowInvoiceRetailers}
        canViewInvoiceStatus={allowInvoiceRetailers}
        {...props}
      />
    )
  }

  Wrapper.displayName = `withPermissions(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withPermissions
